<template>
  <div class="file-list">
    <div v-if="array">
      <row v-for="(file, index) in fileList" :key="index" class="file-row">
        <template v-slot:prefix>
          <svg-icon
            v-if="!['word', 'excel', 'ppt', 'pdf'].includes(getType(file.type))"
            icon-class="detail_common-file"
            style="font-size: 18px;margin-left: -2px"
          ></svg-icon>
          <svg-icon
            v-else
            :icon-class="getType(file.type)"
            style="font-size: 20px;margin-left: -2px"
          ></svg-icon>
        </template>
        {{ file.name }}
        <template v-slot:suffix>
          <span class="operation">
            <i v-if="canPreview(file.type)" class="el-icon-view icon" @click="preview(file)"></i>
            <i class="el-icon-download icon" @click="download(file)"></i>
          </span>
        </template>
      </row>
    </div>
    <div v-else style="display: flex; flex-wrap: wrap;">
      <div v-for="(file, index) in fileList" :key="index" class="image">
        <div class="image-info">
          <img
            v-if="getType(file.type) === 'img'"
            :src="url_prefix + file.path"
            style="width: 100%; height:100%"
          />
          <svg-icon
            v-else-if="['word', 'excel', 'ppt', 'pdf'].includes(getType(file.type))"
            :icon-class="getType(file.type)"
            style="font-size: 50px;"
          ></svg-icon>
          <svg-icon v-else icon-class="detail_common-file" style="font-size: 46px"></svg-icon>
        </div>
        <div class="modal" @click="canPreview(file.type) ? preview(file) : download(file)">
          <span v-tip class="file-name">{{ file.name }}</span>
          <div v-if="canPreview(file.type)" class="operation">
            <span @click.stop="preview(file)" class="pointer">
              <svg-icon icon-class="detail_preview"></svg-icon>
            </span>
            <el-divider direction="vertical" style="background-color: #fff"></el-divider>
            <span @click.stop="download(file)" class="pointer">
              <svg-icon icon-class="detail_download"></svg-icon>
            </span>
          </div>
          <div v-else class="operation">
            <span @click.stop="download(file)" class="pointer">
              <svg-icon icon-class="detail_download"></svg-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
    <file-preview ref="filePreview"></file-preview>
    <file-history ref="fileHistory"></file-history>
  </div>
</template>

<script>
import Row from "@/components/BaseComponents/Panel/Row"
import FileHistory from "./FileHistory"
import FilePreview from "@/components/BaseComponents/FilePreview"
import { url_prefix } from "@/utils/uploadFile"
import { getFileType } from "@/utils/common"
import { download } from "@/utils/aliOss"
import { initOssClient } from "@/store/actions"
import { loadingService } from "@/utils/ui"
import {downloadAttachment} from "@/api/userCenter/file";
import {getCurUser} from "@/api/user";
import {fileWatermark} from "@/api/sheet/sheetData";

export default {
  name: "FileControl",
  components: {
    Row,
    FileHistory,
    FilePreview
  },
  props: {
    files: Array,
    array: Boolean,
    control: Object,
    sheetData: Object,
  },
  inject: ["dataInfo"],
  computed: {
    fileList() {
      return this.files?.filter(f => f) || []
    }
  },
  data() {
    return {
      url_prefix,
      userInfo:"",
    }
  },
  mounted() {
    getCurUser().then((res) => {
      this.userInfo=res.data.data.name;
    })
  },
  beforeCreate() {
    initOssClient()
  },
  methods: {
    getType: getFileType,
    canPreview(type) {
      return this.getType(type) !== null
    },
    preview(file) {
      let fileInfo = {
        url: this.url_prefix + file.path,
        type: this.getType(file.type),
        name: file.name
      }
      this.$refs.filePreview.preview(fileInfo, this.fileList,this.userInfo)
    },
    download(file) {
      if(this.control?.aw){
        fileWatermark(file.id);
        this.$message.success("下载任务已提交，请等待消息通知！")
      }else{
        downloadAttachment(file.id)
        const loadingInstance = loadingService()
        download({ objectName: file.path, downloadName: file.name }).finally(() => {
          loadingInstance.close()
        })
      }
    },
    showFileHistory(controlId,control) {
      let watermark=this.userInfo
      if (controlId === undefined) controlId = "attachment"
      let fileId = `${controlId}_${this.dataInfo.dataId}`
      this.$refs.fileHistory?.open({ fileId,watermark,control })
    },
    showFilesInDialog(filesForShow) {
      let watermark=this.userInfo
      this.$refs.fileHistory?.open({ filesForShow,watermark })
    }
  }
}
</script>

<style lang="scss" scoped>
.file-list {
  .image {
    height: 72px;
    width: 72px;
    margin-right: 4px;
    margin-bottom: 2px;
    margin-top: 2px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    position: relative;
    flex-shrink: 0;
    &:hover {
      .modal {
        visibility: visible;
      }
    }
    .image-info {
      height: 100%;
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .modal {
      background-color: #606266;
      opacity: 0.5;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      visibility: hidden;
      border-radius: 2px;
      .file-name {
        position: absolute;
        font-size: 10px !important;
        width: 60px;
        left: 4px;
        top: 1px;
        color: #fff;
      }
      .operation {
        display: flex;
        position: absolute;
        bottom: -3px;
        right: 4px;
        font-size: 14px;
        ::v-deep {
          .el-divider--vertical {
            margin: 7px 5px 0 5px;
            height: 9px;
          }
        }
      }
    }
  }
  ::v-deep {
    .file-row {
      padding: 0;
      margin-bottom: 0;
      &:hover .prefix {
        color: inherit;
      }
      .suffix:hover {
        color: inherit;
      }
      .suffix {
        i {
          font-weight: bold;
          padding: 3px;
        }
        .icon {
          & + .icon {
            margin-left: 3px;
          }
          &:hover {
            color: $color-main;
          }
        }
      }
    }
  }
}
</style>
